module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm6_en.c18320695660437b6936541ff82731fa.png";